/**
 * Romania-time words for the settings pages (Dependency Sync, Notifications):
 * "today 12:20", "yesterday 18:20", "Sat 16 Oct, 06:00", "2 h ago".
 *
 * The robots and the scheduled mails run on Romania hours, so every time on
 * these pages is shown in Romania time, whatever the reader's computer says.
 * `dateTimeRo` of the harvesting module writes "18/10/2026 à 12:20": correct,
 * but French and slow to read for a status.
 */
const TZ = 'Europe/Bucharest'

function partsOf (d) {
  const dt = d instanceof Date ? d : new Date(d)
  if (!d || isNaN(dt.getTime())) return null
  const p = {}
  new Intl.DateTimeFormat('en-GB', {
    timeZone: TZ,
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23'
  }).formatToParts(dt).forEach((x) => { p[x.type] = x.value })
  // Some engines still write 24:05 for five past midnight.
  if (p.hour === '24') p.hour = '00'
  return p
}

/** The Romania calendar day of an instant, YYYY-MM-DD (to group slots by day). */
export function roDayKey (d) {
  const dt = d instanceof Date ? d : new Date(d)
  if (!d || isNaN(dt.getTime())) return ''
  return new Intl.DateTimeFormat('en-CA', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit' }).format(dt)
}

/** "12:20" */
export function roTime (d) {
  const p = partsOf(d)
  return p ? `${p.hour}:${p.minute}` : '—'
}

/** "Sat 18 Oct" */
export function roDay (d) {
  const p = partsOf(d)
  return p ? `${p.weekday} ${p.day} ${p.month}` : '—'
}

/** "today", "yesterday", "tomorrow", or "Sat 18 Oct". */
export function roDayWord (d, now = new Date()) {
  const key = roDayKey(d)
  if (!key) return '—'
  const day = 86400000
  if (key === roDayKey(now)) return 'today'
  if (key === roDayKey(new Date(now.getTime() - day))) return 'yesterday'
  if (key === roDayKey(new Date(now.getTime() + day))) return 'tomorrow'
  return roDay(d)
}

/** "today 12:20", "yesterday 18:20", "Sat 16 Oct, 06:00". */
export function roWhen (d, now = new Date()) {
  const p = partsOf(d)
  if (!p) return '—'
  const word = roDayWord(d, now)
  return /^(today|yesterday|tomorrow)$/.test(word) ? `${word} ${p.hour}:${p.minute}` : `${word}, ${p.hour}:${p.minute}`
}

/** Hours between an instant and now (null when there is no instant). */
export function hoursSince (d, now = new Date()) {
  const dt = d instanceof Date ? d : new Date(d)
  if (!d || isNaN(dt.getTime())) return null
  return (now.getTime() - dt.getTime()) / 3600000
}

/** 0.4 -> "24 min", 5.2 -> "5 h", 50 -> "2 days". */
export function ago (h) {
  if (h === null || h === undefined || isNaN(h)) return '—'
  if (h < 1) return `${Math.max(1, Math.round(h * 60))} min`
  if (h < 48) return `${Math.round(h)} h`
  return `${Math.round(h / 24)} days`
}
